import React, { useState } from "react";
import JetzigeBeschwerden from "./1.1 Jetzige Beschwerden/JetzigeBeschwerden";
import BisherigerVerlauf from "./1.2 Bisheriger Verlauf/BisherigerVerlauf";
import WeitereErkrankungen from "./1.3 Weitere Erkrankungen/WeitereErkrankungen";
import VegetativeAnamnese from "./1.5 Vegetative Anamnese/VegetativeAnamnese";
import SozialAnamnese from "./2.1 Sozialanamnese/SozialAnamnese";
import ArbeitsAnamnese from "./2.2 Arbeitsanamnese/ArbeitsAnamnese";
import SubjektiveBeeintraechtigung from "./2.3 Subjektive Beeintraechtigung/SubjektiveBeeintraechtigung";
import Allgemeines from "./3 Allgemeines/Allgemeines";

const SozialUndBerufsanamnese = (props) => {
    const [rentner, setRentner] = useState(props.rentner);

    const handleChange = (e) => {
        // console.log(e.target.name, e.target.value)
        if (!e.schmerzliste && e.target.name === "RENTE")
            setRentner(parseInt(e.target.value));
        props.onChange(e.target);
    }

    /* Ausgemustert:
                <SelectField
                value={daten.NATIONALITAET}
                onChange={handleChange}
                width="25%"
                name="NATIONALITAET"
                label={<h3>1. Nationalität</h3>}
                descriptiveText="In welchem Land sind Sie geboren?">
                {!!nationen?.length &&
                    nationen.map(({ NATION_ID, NATION }) => (
                        <option key={NATION_ID} value={NATION_ID}>
                            {NATION}
                        </option>
                    ))
                }
            </SelectField>

                    <CheckboxField
                        name="SCHW_AUS"
                        value={daten.SCHW_AUS === 1 ? "off" : "on"}
                        checked={daten.SCHW_AUS === 1}
                        onChange={handleCheck}
                        label="Merkzeichen"
                    />

                    <CheckboxField
                            name="ARBG_SONST"
                            value={daten.ARBG_SONST === 1 ? "off" : "on"}
                            checked={daten.ARBG_SONST === 1}
                            onChange={handleCheck}
                            label="Sonstige"
                        />

                        <CheckboxField
                            name="BEL_SONST"
                            value={daten.BEL_SONST === 1 ? "off" : "on"}
                            checked={daten.BEL_SONST === 1}
                            onChange={handleCheck}
                            label="Sonstiges:"
                        />
                        {daten.BEL_SONST === 1 &&
                            <TextField
                                name="BEL_SONST_TXT"
                                width="60%"
                                defaultValue={daten.BEL_SONST_TXT}
                                onChange={handleChange}
                                direction="row"
                            />

                                                <h3>17. Probleme am Arbeitsplatz</h3>
                    <h3>16. Technische Hilfsmittel/Persönliche Schutzausrüstung</h3>
                    <TextAreaField
                        name="TECHN_HILF"
                        width="100%"
                        defaultValue={daten.TECHN_HILF}
                        onChange={handleChange}
                        descriptiveText="Geben Sie bitte die benötigten technischen Hilfsmittel ein."
                        wrap="nowrap"
                        maxLength={256}
                        rows={2}
                    />
                    <p></p>
                    <TextAreaField
                        name="PROBL_ARB"
                        width="100%"
                        defaultValue={daten.PROBL_ARB}
                        onChange={handleChange}
                        descriptiveText="Geben Sie bitte die aktuellen Probleme am Arbeitsplatz ein."
                        wrap="nowrap"
                        maxLength={256}
                        rows={2}
                    />
                    <p></p>
                                <TextField
                                    label="seit"
                                    name="AU_DAT"
                                    width="15%"
                                    defaultValue={daten.AU_DAT}
                                    hasError={hasError.AU_DAT}
                                    errorMessage="Ein Datum muss das Format TT.MM.JJJJ haben."
                                    onChange={handleDate}
                                    direction="row"
                                />
                                <TextField
                                    name="AU_12"
                                    label="AU-Zeiten in den letzten 12 Monaten (in Monaten)"
                                    width="50%"
                                    defaultValue={daten.AU_12}
                                    hasError={hasError.AU_12}
                                    errorMessage="Der Wert muß zwischen 0 und 12 liegen."
                                    onChange={(e) => validateInteger(e, 0, 12)}
                                    direction="row"
                                />



                                */



    return (
        <>
            <h2>Anamnesebogen</h2>
            <h3>1   Allgemeine und klinische Anamnese</h3>
            <JetzigeBeschwerden handleChange={handleChange} setHasError={props.setHasError} hasError={props.hasError} readOnly={props.readOnly} />
            <p></p>
            <BisherigerVerlauf handleChange={handleChange} setHasError={props.setHasError} hasError={props.hasError} readOnly={props.readOnly} />
            <p></p>
            <WeitereErkrankungen handleChange={handleChange} setHasError={props.setHasError} hasError={props.hasError} readOnly={props.readOnly} />
            <p></p>
            <h4>1.4	Entfällt/Keine Angaben erforderlich</h4>
            <VegetativeAnamnese handleChange={handleChange} setHasError={props.setHasError} hasError={props.hasError} readOnly={props.readOnly} />
            <p></p>
            <h3>2   Sozialmedizinische Anamnese</h3>
            <SozialAnamnese handleChange={handleChange} setHasError={props.setHasError} hasError={props.hasError} readOnly={props.readOnly} />
            <p></p>
            { rentner <= 0 &&
                <>
                    <ArbeitsAnamnese handleChange={handleChange} setHasError={props.setHasError} hasError={props.hasError} readOnly={props.readOnly} />
                    <p></p>
                    <SubjektiveBeeintraechtigung handleChange={handleChange} setHasError={props.setHasError} hasError={props.hasError} readOnly={props.readOnly} />
                </>
            }
            <p></p>
            <Allgemeines handleChange={handleChange} setHasError={props.setHasError} hasError={props.hasError} readOnly={props.readOnly} />
            <p></p>
        </>
    )
}

export default SozialUndBerufsanamnese;